import { render, staticRenderFns } from "./SubscriptionsList.vue?vue&type=template&id=45f9c564&scoped=true"
import script from "./SubscriptionsList.vue?vue&type=script&lang=js"
export * from "./SubscriptionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f9c564",
  null
  
)

export default component.exports